import {useState} from "react";
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';

const useSelectedItem = (selectedIds, itemTypes, isLimitedItem = false) => {
  const [itemIds, setItemIds] = useState(selectedIds);
  const limitSize = isLimitedItem && itemIds.length >= 3;

  const sectionIds = (() => {
    const sectionTypeIds = itemIds.flatMap(id =>
      itemTypes.filter(itemTypes => itemTypes.id === id).map(itemTypes => itemTypes.sectionTypeId)
    );
    return [...new Set(sectionTypeIds)]
  })();

  const setItemId = itemId => {
    const hasId = itemIds.some(id => id === itemId);

    // 選択されているIDリストへの追加/削除を行う
    if (hasId) {
      const index = itemIds.indexOf(itemId);
      itemIds.splice(index, 1);
    } else {
      if (!limitSize) {
        itemIds.push(itemId);
      }
    }
    setSortedItemIds(itemIds);
  };

  /**
   * 全選択する場合
   * @param sectionId
   */
  const setItemIdsBySection = sectionId => {
    // 選択に制限がかかっているものは、全選択できないようにする
    if (isLimitedItem) {
      return;
    }

    // 対象セクションにあるItem配列
    const itemTypesByTargetSectionUnit = itemTypes
      .filter(itemTypes => itemTypes.sectionTypeId === sectionId);

    // 現在ユーザが選択しているItem配列のうち、対象セクションにあるもの
    const selectedItemTypesByTargetSectionUnit = itemTypes
      .filter(itemType => itemType.sectionTypeId === sectionId)
      .filter(itemType => itemIds.some(itemId => itemId === itemType.id));

    // セクションのItem配列とユーザが選んでいた配列が同じか
    const isAllSelectedBySectionUnit =
      itemTypesByTargetSectionUnit
        .every(itemType => selectedItemTypesByTargetSectionUnit
          .some(targetItemType => targetItemType.id === itemType.id));

    if (isAllSelectedBySectionUnit) {
      // 対象セクションにあるアイテムを選択済IDから省いて登録する
      const filteredItemIds =
        itemIds.filter(itemId => !selectedItemTypesByTargetSectionUnit.some(iType => iType.id === itemId));

      setSortedItemIds(filteredItemIds);
    } else {
      // 対象セクションにあるアイテムをすべて選択して登録する
      itemIds.push(...itemTypesByTargetSectionUnit.map(i => i.id));
      setSortedItemIds([...new Set(itemIds)]);
    }
  };

  /**
   * itemTypeのsort順でsortする
   * @param selectedIds
   */
  const setSortedItemIds = selectedIds => {
    const sortedItemIds = itemTypes
      .filter(itemType => selectedIds.some(selectedId => itemType.id === selectedId))
      .sort((current, next) => current.sort - next.sort)
      .map(itemType => itemType.id);

    setItemIds([...new Set(sortedItemIds)]);
  };

  return [itemIds, sectionIds, setItemId, setItemIdsBySection];
};

export default useSelectedItem;
